import { useState } from 'react';
import { appendOrderNote } from '../../../../axios/orderDetail';

interface UseNoteResponseResult {
  submitting: boolean;
  error: string | null;
  submitNote: (note: string) => Promise<void>;
}

export function useNoteResponse(soNo: string, onSuccess: () => void, versionLabel?: string): UseNoteResponseResult {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const submitNote = async (note: string) => {
    setSubmitting(true);
    setError(null);

    try {
      await appendOrderNote(soNo, note, versionLabel);
      onSuccess();
    } catch (err: any) {
      setError(
        err?.response?.data?.message ?? err?.message ?? 'Failed to submit note. Please try again.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, error, submitNote };
}
